import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { ProposalsRequestModel } from '../../helpers/objects/request/proposals/proposals-request-model';
import { ProposalsResponseModel } from '../../helpers/objects/response/proposals/proposals-response-model';
import { ProposalDetailModel } from '../../helpers/objects/dto/proposal-detail/proposal-detail-model';
import { ProposalInsuredPeopleResponseModel } from '../../helpers/objects/response/proposal-insured-people/proposal-insured-people-response-model';
import { ProposalAttachmentsResponseModel } from '../../helpers/objects/response/proposal-attachments-response/proposal-attachments-response-model';
import { Router, UrlSerializer } from '@angular/router';
import { UploadedProposalAttachmentModel } from '../../helpers/objects/dto/uploaded-proposal-attachment/uploaded-proposal-attachment-model';
import { TranslateService } from '@ngx-translate/core';
import {
  MediaDigitalArchiveResponseModel
} from '../../helpers/objects/response/media-digital-archive/media-digital-archive-response-model';

@Injectable({
  providedIn: 'root'
})
export class ProposalsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(
    @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel,
    private http: HttpClient,
    private router: Router,
    private translateService: TranslateService,
    private serializer: UrlSerializer
  ) {
    this.appConfig = appConfigTemp;
  }

  get(filter: ProposalsRequestModel): Observable<ProposalsResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });
    return this.http
      .get<any>(this.appConfig.api + 'proposals/' + this.appConfig.apiPartnershipId, {
        params: httpParams
      })
      .pipe(map((response) => response.body as ProposalsResponseModel));
  }

  getDetails(id: string): Observable<ProposalDetailModel> {
    return this.http
      .get<any>(this.appConfig.api + 'proposals/' + this.appConfig.apiPartnershipId + '/' + id)
      .pipe(map((response) => response.body.proposalDetail as ProposalDetailModel));
  }

  getInsuredPeople(id: string): Observable<ProposalInsuredPeopleResponseModel> {
    return this.http
      .get<any>(this.appConfig.api + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + id + '/insured-people')
      .pipe(map((response) => response.body as ProposalInsuredPeopleResponseModel));
  }

  getProposalPdf(id: string): Observable<MediaDigitalArchiveResponseModel> {
    return this.http.get<any>(this.appConfig.api + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + id + '/print')
      .pipe(map(response => response.body as MediaDigitalArchiveResponseModel))
  }

  getAttachments(id: string): Observable<ProposalAttachmentsResponseModel> {
    return this.http
      .get<any>(this.appConfig.api + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + id + '/attachments')
      .pipe(map((response) => response.body as ProposalAttachmentsResponseModel));
  }

  openProposalAttachment(proposalId: string, attachmentId?: number): string {
    //https://ws.future-healthcare.net/tst/api/fhc/fhsp/subscription/sp/proposals/{proposalId}/attachments/{attachmentId}?Authorization={jwtToken}
    const params = {
      Authorization: sessionStorage.getItem('token')
    };
    const query = this.router.createUrlTree([], { queryParams: params });
    return (
      this.appConfig.api +
      'subscription/' +
      this.appConfig.apiPartnershipId +
      '/proposals/' +
      proposalId +
      '/attachments/' +
      attachmentId +
      '?' +
      (this.serializer.serialize(query).split('?')[1] || '')
    );
  }

  setPropostalAttachment(proposalId: string, guidStr: string): Observable<UploadedProposalAttachmentModel> {
    const body = {
      guid: guidStr
    };
    return this.http
      .post<any>(this.appConfig.api + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + proposalId + '/attachments', body)
      .pipe(map((response) => response.body as UploadedProposalAttachmentModel));
  }

  download(filter: ProposalsRequestModel): string {
    const extraParams = {
      pageSize: 10000,
      page: 1,
      Authorization: sessionStorage.getItem('token'),
      location: this.translateService.currentLang
    };
    const params = { ...filter, ...extraParams };
    const query = this.router.createUrlTree([], { queryParams: params });
    return this.appConfig.api + 'proposals-worksheet/' + this.appConfig.apiPartnershipId + '?' + (this.serializer.serialize(query).split('?')[1] || '');
  }
}
